import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import { ApiTest } from "./components/test/ApiTest";
import Loading from "./components/uikit/atoms/Loading";
import Router from "./router/Router";
import { useRecoilState } from "recoil";
import { userState } from "./states/userState";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "./theme/theme";
import { performance } from "./firebase";
function App() {
  const [user, setUser] = useRecoilState(userState);
  console.log("App:user", user, user.isAuth);
  useEffect(() => {
    console.log("App:user", user, user.isAuth);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Loading>
        <div className="c-main">
          <Router />
          {/* <ApiTest /> */}
        </div>
      </Loading>
    </ThemeProvider>
  );
}

export default App;
